import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { useEffect, useState } from "react";

interface StripeRedirectModalProps {
  open: boolean;
  stripeUrl: string | null;
}

const StripeRedirectModal = ({ open, stripeUrl }: StripeRedirectModalProps) => {
  const { lang } = useLanguage();
  const es = lang === "es";
  const [dots, setDots] = useState("");

  useEffect(() => {
    if (!open) return;
    const interval = setInterval(() => {
      setDots((prev) => (prev.length >= 3 ? "" : prev + "."));
    }, 500);
    return () => clearInterval(interval);
  }, [open]);

  useEffect(() => {
    if (!open || !stripeUrl) return;
    // Redirect immediately; the modal stays visible during the navigation.
    window.location.href = stripeUrl;
  }, [open, stripeUrl]);

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-sm text-center [&>button]:hidden" onPointerDownOutside={(e) => e.preventDefault()}>
        <div className="flex flex-col items-center gap-4 py-6">
          <Loader2 className="w-10 h-10 text-foreground animate-spin" />
          <p className="font-display text-lg font-semibold text-foreground">
            {es ? "Redirigiendo a la pasarela de pago" : "Redirecting to payment gateway"}
            {dots}
          </p>
          <p className="font-body text-sm text-muted-foreground">
            {es ? "No cierres esta ventana" : "Do not close this window"}
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default StripeRedirectModal;
